const firebaseConfig = {
  apiKey: 'AIzaSyAlmu2FfEU06co1gBAmZhlMv4_q8y28mTU',
  authDomain: 'help-me-labeling.firebaseapp.com',
  projectId: 'help-me-labeling',
  storageBucket: 'help-me-labeling.appspot.com',
  messagingSenderId: '783187226370',
  appId: '1:783187226370:web:30668c9b0153c6cf201c1b',
};

export { firebaseConfig };
